// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"fdecd4ee","805":"b696daee"}[chunkId] + ".chunk.css";
};